import { render, staticRenderFns } from "./AddSectionDialog.vue?vue&type=template&id=596ab7a4&scoped=true&lang=pug&"
import script from "./AddSectionDialog.vue?vue&type=script&lang=js&"
export * from "./AddSectionDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddSectionDialog.vue?vue&type=style&index=0&id=596ab7a4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596ab7a4",
  null
  
)

/* custom blocks */
import block0 from "./AddSectionDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports